<template>
  <div
    v-loading="loading"
    class="yxtbiz-teacher-rd-salary-audit"
  >
    <div class="yxtbiz-teacher-rd-salary-audit__title">{{ $t('pc_biz_te_lbl_billing_info' /* 结算信息 */) }}</div>
    <div class="mt24">
      <div class="yxtbiz-teacher-rd-salary-audit__info-wrapper">
        <div
          v-for="info in auditLists"
          :key="info.name"
          class="w-50p yxtbiz-teacher-rd-salary-audit__info-line"
        >
          <span class="color-gray-7 d-in-block lh22">{{ info.name }}</span>
          <yxtf-tooltip
            open-filter
            placement="top"
          >
            <yxtbiz-user-name
              slot="content"
              :name="info.value || '--'"
            />
            <yxtbiz-user-name
              :name="info.value || '--'"
              class="color-gray-10 d-in-block lh22 ellipsis w-max-70p nowrap"
            />
          </yxtf-tooltip>
        </div>
      </div>
      <yxt-button
        type="text"
        class="mt24"
        :disabled="!formId"
        @click="viewDetail"
      >
        {{$t('pc_biz_te_view_salarydetail' /* 查看薪酬结算单详情 */)}}
      </yxt-button>
    </div>
  </div>
</template>

<script>
import { getAuditFormInfo } from '../service';

export default {
  name: 'YxtbizTeacherRdSalaryAudit',
  name_zh: '讲师研发课薪酬审核',
  eventList: [
  ],
  props: {
    formId: {
      type: String,
      required: true,
      desc: '审核 formId',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      loading: false,
      auditLists: [
        { name: `${this.$t('pc_biz_te_lbl_billingname' /* 结算人 */)}：`, key: 'name', value: '' },
        { name: `${this.$t('pc_biz_te_lbl_billingtime' /* 结算时间 */)}：`, key: 'time', value: '' }
      ]
    };
  },
  mounted() {
    if (!this.formId) return;
    this.loading = true;
    getAuditFormInfo(this.formId).then(res => {
      const { submitUserName, submitTime } = res;
      this.auditLists = this.auditLists.map(audit => {
        if (audit.key === 'name') audit.value = submitUserName || '--';
        if (audit.key === 'time') audit.value = submitTime || '--';
        return audit;
      });
    }).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    viewDetail() {
      let href = window.location.origin + `/te/#/coursesalarysettlement/${this.formId}/auditview`;
      window.open(href, '_blank');
    }
  }
};
</script>
